import IconBank from "assets/icons/Bank";
import IconBrain from "assets/icons/Brain";
import IconMedal from "assets/icons/Medal";
import Section from "components/Section";
import Title from "components/Title";
import { motion } from "framer-motion";
import React, { useMemo } from "react";
import { framerMotionAnimation } from "utils/animation";
import urls from "utils/urls";
import styles from "./styles.module.scss";

const About: React.FC = () => {
  const reasons = useMemo(
    () => [
      {
        icon: <IconMedal />,
        title: "Unmatched Quality",
        description:
          "We pride ourselves on delivering top-tier solar solutions using premium materials and proven techniques. Our systems are built to last, ensuring reliable, efficient energy for years to come.",
      },
      {
        icon: <IconBrain />,
        title: "Trusted Expertise",
        description:
          "With years of experience and a team of skilled professionals, we bring unparalleled knowledge and precision to every project. From planning to installation, our expertise guarantees excellence at every step.",
      },
      {
        icon: <IconBank />,
        title: " Affordable Sustainability",
        description:
          "Going solar doesn’t have to break the bank. We design cost-effective solutions that maximize savings without compromising on performance or durability, making green energy accessible to all.",
      },
    ],
    []
  );

  return (
    <Section
      contentClassName={styles.content}
      id="about"
      label="About Us"
      labelClassName={styles.label}
    >
      <div className={styles.left}>
        <Title
          className={styles.title}
          title="<highlight>Clean Energy</highlight> for Every Filipino"
        />

        <motion.div
          className={styles.image}
          style={{
            backgroundImage: `url(${urls.images("sections/about.jpg")})`,
          }}
          {...framerMotionAnimation}
        />
      </div>

      <div className={styles.right}>
        <motion.p {...framerMotionAnimation}>
          Renewable Philippines was founded by Rafael Maceda, a young Filipino
          engineer committed to making solar power accessible for all. While
          solar solutions are available, affordability often remains a barrier.
          Our mission is to break down these barriers by delivering
          cost-effective, sustainable energy options tailored for homes,
          businesses, and communities across the Philippines.
        </motion.p>

        <div className={styles.list}>
          {reasons.map((reason, index) => (
            <motion.div
              className={styles.item}
              key={reason.title}
              {...framerMotionAnimation}
            >
              <div className={styles.header}>
                <div className={styles.image}>{reason.icon}</div>
                <h3 className={styles.title}>{reason.title}</h3>
              </div>
              <p>{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default About;
